import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './IconFullscreen.module.css';

const IconFullscreen = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="500"
      zoomAndPan="magnify"
      viewBox="0 0 375 375"
      height="500"
      preserveAspectRatio="xMidYMid meet"
      version="1.2"
    >
      <defs>
        <clipPath id="d8a161aa9d">
          <path d="M 208 112.5 L 262.5 112.5 L 262.5 167 L 208 167 Z M 208 112.5 "/>
        </clipPath>
        <clipPath id="ea26bac769">
          <path d="M 112.5 208 L 167 208 L 167 262.5 L 112.5 262.5 Z M 112.5 208 "/>
        </clipPath>
      </defs>
      <g id="81671205d0">
        <g clipRule="nonzero" clipPath="url(#d8a161aa9d)">
          <path style=" stroke:none;fill-rule:nonzero;fill:#000000;fill-opacity:1;" d="M 223.808594 120.402344 L 251.003906 119.40625 L 208.332031 162.078125 L 212.917969 166.664062 L 255.582031 124 L 254.585938 151.179688 L 261.074219 151.410156 L 262.484375 112.5 L 223.578125 113.914062 Z M 223.808594 120.402344 "/>
        </g>
        <g clipRule="nonzero" clipPath="url(#ea26bac769)">
          <path style=" stroke:none;fill-rule:nonzero;fill:#000000;fill-opacity:1;" d="M 162.082031 208.324219 L 119.417969 250.988281 L 120.414062 223.808594 L 113.925781 223.578125 L 112.515625 262.488281 L 151.421875 261.070312 L 151.191406 254.585938 L 123.996094 255.582031 L 166.667969 212.910156 Z M 162.082031 208.324219 "/>
        </g>
        <path style="fill:none;stroke-width:4;stroke-linecap:butt;stroke-linejoin:miter;stroke:#000000;stroke-opacity:1;stroke-miterlimit:4;" d="M -0.00117846 2.001632 L 3.532118 2.00067 " transform="matrix(-0.153872,0.734046,-0.734046,-0.153872,119.574577,254.289329)"/>
      </g>
    </svg>
  );
};

IconFullscreen.defaultProps = {
  rootClassName: null,
  className: null,
};

const { string } = PropTypes;

IconFullscreen.propTypes = {
  rootClassName: string,
  className: string,
};

export default IconFullscreen;
